import { Skeleton } from "@mui/material"
import { Box, CardContent, Card, Grid } from "@mui/material"

const SummaryCardsSkeletons = () => {
  return (
    <Box>
      {/* Summary Cards Skeleton */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[1, 2, 3, 4].map((index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card>
              <CardContent sx={{ textAlign: "center" }}>
                <Skeleton variant="circular" width={32} height={32} sx={{ mx: "auto", mb: 1 }} />
                <Skeleton variant="text" width={60} height={32} sx={{ mx: "auto" }} />
                <Skeleton variant="text" width={120} height={20} sx={{ mx: "auto" }} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Alerts Skeleton */}
      <Box sx={{ mb: 3 }}>
        <Skeleton variant="rectangular" height={48} sx={{ mb: 1, borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={48} sx={{ borderRadius: 1 }} />
      </Box>

      {/* Table Skeleton */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Skeleton variant="text" width={200} height={24} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 1 }} />
        </CardContent>
      </Card>

      {/* Action Buttons Skeleton */}
      <Box display="flex" justifyContent="flex-end" gap={2}>
        <Skeleton variant="rectangular" width={80} height={42} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" width={120} height={42} sx={{ borderRadius: 1 }} />
      </Box>
    </Box>
  )
}

export default SummaryCardsSkeletons
